import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './App.css';
// Wave UX-2.1 Item 1 (2026-05-23) — 외부 바이어 웹 i18n 인프라.
// ERP 라우트는 useT 호출 없음 — 영향 0. 외부 바이어 (/buyer/*) 만 활용.
import { I18nProvider } from './i18n/I18nProvider';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <I18nProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </I18nProvider>
);
